export const white = '#FFF';
export const black = '#000';

export const royalLighter = '#F0F6FC';
export const royalLight = '#CEE4FA';
export const royalBase = '#326DEC';
export const royalDark = '#005CB8';
export const royalDarker = '#004487';
export const brandBlue = '#2A2AE9';

export const slateLighter = '#8490A4';
export const slateLight = '#506482';
export const slateBase = '#3C4A62';
export const slateDark = '#212936';
export const slateDarker = '#212936';

// export const grayLighter = '#FFFFFF';
export const grayLight = '#F8F9FA';
export const grayBase = '#E8EBF0';
export const grayDark = '#D4DAE0';
export const grayDarker = '#ACB4C2';

export const lilacLighter = '#F5EEFB';
export const lilacLight = '#EFD5F6';
export const lilacBase = '#B340D0';
export const lilacDark = '#9300B8';
export const lilacDarker = '#6C0087';

// export const moodyLighter = '#E9E9FE';
// export const moodyLight = '#BEBDF1';
// export const moodyBase = '#5E5CC4';
// export const moodyDark = '#3B39AC';
// export const moodyDarker = '#020087';

export const appleLighter = '#F2FCF4';
export const appleLight = '#B8E7AB';
export const appleBase = '#5CCC3D';
export const appleDark = '#4CA732';
export const appleDarker = '#006936';

export const emeraldLighter = '#EAFFF3';
export const emeraldLight = '#ACF0C8';
export const emeraldBase = '#50C882';
export const emeraldDark = '#2DAD63';
export const emeraldDarker = '#006936';

export const watermelonLighter = '#FFEEEE';
export const watermelonLight = '#FCC0C0';
export const watermelonBase = '#E4100E';
export const watermelonDark = '#B40909';
export const watermelonDarker = '#900000';

export const blazeLighter = '#FFF3EB';
export const blazeLight = '#FFD8BC';
export const blazeBase = '#F6610C';
export const blazeDark = '#B74707';
export const blazeDarker = '#762E04';

export const sunglowLighter = '#FFFCF1';
export const sunglowLight = '#FFF4C3';
export const sunglowBase = '#FFD22D';
export const sunglowDark = '#E9B700';
export const sunglowDarker = '#836B20';

export const smokeLightest = '#FAFAFA';
export const smokeLighter = '#EFEFEF';
export const smokeLight = '#DFDFDF';
export const smokeBase = '#C2C2C2';
export const smokeDark = '#A3A3A3';
export const smokeDarker = '#828282';
export const smokeDarkest = '#646464';

export const chimneyLightest = '#444444';
export const chimneyLighter = '#373737';
export const chimneyLight = '#333333';
export const chimneyBase = '#272727';
export const chimneyDark = '#222222';
export const chimneyDarker = '#121212';
export const chimneyDarkest = '#0F0F0F';
